import _export from '../internals/export.js';
import functionUncurryThis from '../internals/function-uncurry-this.js';
import '../internals/object-get-own-property-descriptor.js';
import toLength$1 from '../internals/to-length.js';
import toString$1 from '../internals/to-string.js';
import notARegexp from '../internals/not-a-regexp.js';
import requireObjectCoercible$1 from '../internals/require-object-coercible.js';
import correctIsRegexpLogic from '../internals/correct-is-regexp-logic.js';
import { __exports as objectGetOwnPropertyDescriptor } from '../../../../../../_virtual/object-get-own-property-descriptor.js';

var $ = _export;
var uncurryThis = functionUncurryThis;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$1;
var toString = toString$1;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$1;
var correctIsRegExpLogic = correctIsRegexpLogic;

var un$EndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith'); // https://github.com/zloirock/core-js/pull/702

var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}(); // `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith

$({
  target: 'String',
  proto: true,
  forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
  endsWith: function endsWith(searchString
  /* , endPosition = @length */
  ) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return un$EndsWith ? un$EndsWith(that, search, end) : slice(that, end - search.length, end) === search;
  }
});
